import React from 'react';

export const useGetSum = (value) => {
    const parsedValue = numberFormatter.parseNumber(value);
    const absValue = Math.abs(parsedValue || 0);
    const rounded = Math.round(absValue * 100);
    const intPart = Math.floor(rounded / 100);
    const fracPart = rounded % 100;

    const float = numberFormatter.formatNumber(intPart, 0);
    const kopecks = String(fracPart).padStart(2, '0');

    return { float, kopecks };
};
